import styled from 'styled-components';
import { breakpoint, theme } from '../../../theme';

export const ActionButtonsSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  min-width: 100%;
  flex: 1 1 auto;

  ${breakpoint('sm')`
    min-width: fit-content;
    flex: 2 1 auto;
  `}

  /**
  * Any nested buttons will:
  * - not wrap their content
  * - fill their parent wrapper
  */
  > * {
    min-width: fit-content;
    width: 50%;
    ${breakpoint('md')`
      width: fit-content;
    `}

    & + * {
      margin-left: ${theme.spacings[1].rem};

      ${breakpoint('md')`
        margin-left: ${theme.spacings[2].rem};
      `}
    }

    /**
     * Nested buttons are full width of button wrapper
    */
    & > button {
      width: 100%;
    }

    /**
     * Nested button links only need to have vertical padding removed
    */
    & > a {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  /**
  * multiple children (buttons) will:
  * - each fill 1/3rd of available space
  */
  > *:not(:only-child) {
    ${breakpoint('md')`
        flex-basis: 33%;
      `}
    flex-basis: 50%;
  }
`;
